import { useEffect } from 'react'
import { useGetZendeskLogin } from './api/getZandeskLogin'
import { Window } from 'Types/Zendesk'

const MESSENGER = 'messenger'

export const useZendeskChat = () => {
  const { data } = useGetZendeskLogin()
  const isConnected = data && data?.token
  const isZendeskFunc = 'zE' in window && typeof window.zE === 'function'
  const _window = window as unknown as Window // window is not a Window, but we can cast it to one

  // Login user, run if userId changes
  useEffect(() => {
    const token = data?.token
    if (isZendeskFunc && isConnected && token) {
      _window.zE(MESSENGER, 'loginUser', (callback: (tokenStr: string) => void) => callback(token))
    }
  }, [isConnected, data, isZendeskFunc, _window])

  const openChat = () => {
    if (isZendeskFunc) _window.zE(MESSENGER, 'open')
  }
  const closeChat = () => {
    if (isZendeskFunc) _window.zE(MESSENGER, 'close')
  }
  const logoutUser = () => {
    if (isZendeskFunc) _window.zE(MESSENGER, 'logoutUser')
  }

  return {
    data,
    isConnected,
    openChat,
    closeChat,
    logoutUser,
  }
}
